import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import { rotas as boleto } from '../views/boleto';
import { rotas as descadastrar } from '../views/descadastrar';
import { rotas as info } from '../views/info';
import { rotas as login } from '../views/login';
import { rotas as meusDados } from '../views/meus-dados';
import { rotas as renegociacao } from '../views/renegociacao';
import { rotas as erro } from '../views/erro';
import { rotas as home } from '../views/home';
import { rotas as nps } from '../views/nps';
import { rotas as pesquisa } from '../views/pesquisa/rotas';
export default [].concat(_toConsumableArray(boleto), _toConsumableArray(descadastrar), _toConsumableArray(erro), _toConsumableArray(home), _toConsumableArray(info), _toConsumableArray(login), _toConsumableArray(meusDados), _toConsumableArray(renegociacao), _toConsumableArray(nps), _toConsumableArray(pesquisa));